import { render } from "./aboutStart.vue?vue&type=template&id=3399a670"
const script = {}

import "./aboutStart.vue?vue&type=style&index=0&id=3399a670&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__